import { render, staticRenderFns } from "./dynamic_islands_container.vue?vue&type=template&id=4336b425&scoped=true"
import script from "./dynamic_islands_container.vue?vue&type=script&lang=js"
export * from "./dynamic_islands_container.vue?vue&type=script&lang=js"
import style0 from "./dynamic_islands_container.vue?vue&type=style&index=0&id=4336b425&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4336b425",
  null
  
)

export default component.exports